module.exports = __webpack_public_path__ + "media/login.1c6df158.mp4";